import React from "react";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import { useTranslations } from "adapters/i18n";

export const formatDateTime = (date) =>
  dayjs(date).isValid() ? dayjs(date).format("DD/MM/YY, [às] HH:mm") : "";

export function TotalHerd({
  operationDate,
  total,
  category,
  pasture,
  customStyles,
  ...props
}) {
  const { t } = useTranslations();
  const formattedDate = formatDateTime(operationDate);
  const animalText = total === 1 ? t("movements:animal.singular") : t("movements:animal.plural");

  return (
    <div style={{ ...styles.wrapper, ...customStyles }} {...props}>
      <p style={styles.title}>{t("pendency:total-animals-on-operation-day")}</p>
      <div style={styles.info}>
        {formattedDate && category && pasture && total !== null
          ? t("pendency:info-animals-on-operation-day", {
              formattedDate,
              total,
              animalText,
              category,
              pasture,
            })
          : t("common:status.loading")}
      </div>
    </div>
  );
}

TotalHerd.propTypes = {
  operationDate: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  categoryName: PropTypes.string.isRequired,
  pastureName: PropTypes.string.isRequired,
  customStyles: PropTypes.object,
};

const styles = {
  wrapper: {
    borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
    fontFamily: "Roboto, sans-serif",
  },
  title: {
    fontSize: "12px",
    color: "rgba(0, 0, 0, 0.54)",
    margin: 0,
  },
  info: {
    padding: "6px 0 0",
    fontSize: "12px",
    color: "rgba(0, 0, 0, 0.54)",
  },
};
